import ShPopConfirm from '@/components/Helpers/ShPopConfirm';
import ShIconWithDescription from '@/components/Helpers/ShIconWithDescription';
import moment from 'moment';
// @vue/component
export default {
  name: 'SmsHistoryListItem',

  components: {
    ShPopConfirm,
    ShIconWithDescription,
  },

  props: {
  statusList: {
    type: Array,
    default: () => [],
  },
  typeList: {
    type: Array,
    default: () => [],
  },
  item: {
    type: Object,
    default: () => ({}),
  }
},

  data() {
    return {
    };
  },

  computed: {
    smsStatus() {
      return this.statusList.find(item => item.status === this.item.status);
    },
    smsType() {
      return this.typeList.find(item => item.typ === this.item.type);
    },
    isSmsPlannedForLater() {
      return moment(this.item.stamp).isAfter()
    },
  },
}
